<template>
    <video-iframe
        v-if="isIframe"
        :poster="poster"
        :src="src"
        :iframeAttrs="iframeAttrs"
    />
    <video-js
        v-else
        :poster="poster"
        :src="src"
        :muted="muted"
        :loop="loop"
        :autoplay="autoplay"
        :title="title"
        :width="width"
    />
</template>

<script>
import { VideoJs } from './components/VideoJs'
import { VideoIframe, sitesName } from './components/VideoIframe'

export default {
    name: 'z-video',
    components: {
        VideoJs,
        VideoIframe
    },
    props: {
        poster: {
            type: String
        },
        src: {
            type: [String, Array],
            required: true
        },
        muted: {
            type: Boolean,
            default: true
        },
        loop: {
            type: Boolean,
            default: false
        },
        autoplay: {
            type: Boolean,
            default: true
        },
        title: {
            type: String
        },
        width: {
            type: String
        },
        iframeAttrs: {
            type: Object
        }
    },
    computed: {
        isIframe () {
            return typeof this.src === 'string' && new RegExp(`https?:\\/\\/(www\\.)?(${sitesName.join('|')})`).test(this.src)
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
